
module.exports = function clean_ci(ci){
  return ci.replace(/\D/g, '');
}